module.exports = __webpack_public_path__ + "static/media/whishlist-black.77100eea.svg";